<div class="section">
    <div class="nova__label">Bill Rate</div>
    <div data-qa-id="an_rjd_rates_hourlybillrate_readonly">
        <img *ngIf="job.isMarginBooster" src="/assets/images/currency_dollar_green.png" title="Margin booster"
            alt="bill rate" class="hourly-bill-rate-icon" /> {{ job.blendedBillRate | currency
        }}{{payFormatPeriodSpecification}}
    </div>

    <div class="nova__label">Holiday Bill Rate</div>
    <div data-qa-id="an_rjd_rates_holidayhourlybillrate_readonly">
        <ng-container
            *ngIf="job.additionalBillRate?.holidayHourlyBillRate && job.additionalBillRate?.holidayHourlyRateFactor;else nullNa">
            {{ job.additionalBillRate.holidayHourlyBillRate | currency }}{{payFormatPeriodSpecification}} ({{
            job.additionalBillRate.holidayHourlyRateFactor }})
        </ng-container>
    </div>

    <div class="nova__label">Overtime Bill Rate</div>
    <div data-qa-id="an_rjd_rates_overtimebillrate_readonly">
        <ng-container
            *ngIf="job.additionalBillRate?.overtimeHourlyRate && job.additionalBillRate?.overtimeHourlyRateFactor;else nullNa">
            {{ job.additionalBillRate?.overtimeHourlyRate | currency }}{{payFormatPeriodSpecification}} ({{
            job.additionalBillRate?.overtimeHourlyRateFactor }})
        </ng-container>
    </div>

    <div class="nova__label">Call Bill Rates</div>
    <div class="data-column">
        <div>24hr Call</div>
        <div data-qa-id="an_rjd_rates_twentyfourhourlybillrate_readonly">
            <ng-container *ngIf="job.additionalBillRate?.twentyFourHourCallBillRate;else nullNa">
                {{ job.additionalBillRate?.twentyFourHourCallBillRate | currency }}/day
            </ng-container>
        </div>

        <div> Night Call</div>
        <div data-qa-id="an_rjd_rates_night_call_bill_rate_readonly">
            <ng-container *ngIf="job.additionalBillRate?.nightCallBillRate;else nullNa">
                {{ job.additionalBillRate?.nightCallBillRate | currency }}{{nightCallBillRateTypeDisplay}}
            </ng-container>
        </div>

        <div>Weekend Call</div>
        <div data-qa-id="an_rjd_rates_weekend_hourly_bill_rate_readonly">
            <ng-container *ngIf="job.additionalBillRate?.weekendHourlyBillRate;else nullNa">
                {{ job.additionalBillRate?.weekendHourlyBillRate | currency }}{{weekendCallPeriodSpecification}}
            </ng-container>
        </div>

        <div>Call Back</div>
        <div data-qa-id="an_rjd_rates_callback_hourly_bill_rate_readonly">
            <ng-container *ngIf="job.additionalBillRate?.callBackHourlyBillRate;else nullNa">
                {{ job.additionalBillRate?.callBackHourlyBillRate | currency }}{{weekendCallPeriodSpecification}}
            </ng-container>
        </div>
    </div>

    <ng-container>
        <div class="nova__label">Pay Range</div>

        <div *ngIf="job.weeklyPayHigh && job.weeklyPayHigh > 0">

            <div data-qa-id="an_rjd_rates_weeklypay_readonly" class="sub-section"
                *ngIf="(!job.weeklyPayLow || job.weeklyPayLow === 0)  && job.weeklyPayHigh > 0">
                Up to {{job.weeklyPayHigh | currency}}{{payRangePeriodSpecification}}
            </div>

            <div data-qa-id="an_rjd_rates_weeklypay_readonly" class="sub-section"
                *ngIf="job.weeklyPayLow && job.weeklyPayLow > 0  && job.weeklyPayLow !== job.weeklyPayHigh">
                {{job.weeklyPayLow | currency}}{{payRangePeriodSpecification}} to {{job.weeklyPayHigh |
                currency}}{{payRangePeriodSpecification}}
            </div>

            <div data-qa-id="an_rjd_rates_weeklypay_readonly" class="sub-section"
                *ngIf="job.weeklyPayLow && job.weeklyPayLow > 0  && job.weeklyPayLow === job.weeklyPayHigh">
                {{job.weeklyPayLow | currency}}{{payRangePeriodSpecification}}
            </div>

            <div data-qa-id="an_rjd_rates_pay_format_external"
                *ngIf="!displayConfigData?.hidePayFormat && (displayConfigData?.payRate !== '' && displayConfigData?.payRate !== null)">
                <span class="external-info">
                    <span class="material-icons">info</span>Displays as "{{payFormat}}"
                </span>
            </div>

        </div>

        <div *ngIf="!job.weeklyPayHigh || job.weeklyPayHigh < 1">Contact AM</div>


    </ng-container>
</div>

<ng-template #nullNa>{{ null | nullNa }}</ng-template>